import { render, staticRenderFns } from "./MoreIcon.vue?vue&type=template&id=61add772&scoped=true&"
import script from "./MoreIcon.vue?vue&type=script&lang=js&"
export * from "./MoreIcon.vue?vue&type=script&lang=js&"
import style0 from "./MoreIcon.vue?vue&type=style&index=0&id=61add772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61add772",
  null
  
)

export default component.exports